@let bot = config()?.bot;

<form
    (submit)="chatMessage && addNewMessage()"
    class="flex h-full bg-white">
    <label
        for="chat-message"
        class="inline-block flex-1">
        <input
            [(ngModel)]="chatMessage"
            autocomplete="off"
            id="chat-message"
            type="text"
            name="chatMessage"
            class="border-0 form-control rounded-r-none rounded-l-none inset-ring-0 placeholder:text-primary-300 py-3.5"
            [placeholder]="speakModeRecorded ? bot?.speakMode?.speak : bot?.speakMode?.message" />
    </label>
    <button
        type="submit"
        class="px-6"
        title="Send">
        <big-icon
            [icon]="iconPlane"
            [size]="'w-4'"
            class="fill-primary" />
    </button>
</form>
